import React, { useEffect, useMemo, useState } from "react";
import BaseModal from "../../../global/components/Modals/BaseModal";
import { Input } from "@vds/inputs";
import { Loader } from "@vds/loaders";
import { useDispatch, useSelector } from "react-redux";
import { updateCameraOnboaredReq } from "../../../store/actions";

const ManualCameraUserLogin = ({
  fovData,
  setOpenModal,
  openModal,
  cameraDetails,
  companionDetails,
  username,
  upass
}) => {
  const [uname, setUname] = useState("service");
  const [pass, setPass] = useState("Service.1234");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
 
  const handleClose = () => {
    setOpenModal(false);
  };
  const { cameraUpdateStatus } = useSelector((state) => state.deviceReducer);

  useEffect(() => {
    if (cameraUpdateStatus && Object.keys(cameraUpdateStatus).length) {
      setOpenModal(false);
      setLoader(false);
    }
  }, [cameraUpdateStatus]);

  useEffect(() => {
    if (username && upass) {
      setUname(username);
      setPass(upass);
    }
  }, [username,upass]);

  const handleSubmit = () => {
    setLoader(true);
    const payload = {
      userName: uname,
      pass: pass,
      companionQrcode: companionDetails[0]?.qrcode,
      cameraDetailsId: cameraDetails?.qrcode,
      fovData: fovData,
    };
    dispatch(updateCameraOnboaredReq(payload));
  };

  return (
    <>
    {loader && <Loader active={true} fullscreen={true} disableFocusLock />}
    <BaseModal
      opened={openModal}
      title="Camera credentials"
      closeButtonText={"Cancel"}
      primaryButtonText={"Submit"}
      onBack={handleClose}
      onClose={handleClose}
      onCloseButtonClick={handleSubmit}
      width="560px"
    >
      <div className="manual-login__inputs-row">
        <Input
          type="text"
          label="Username"
          placeholder=""
          required={true}
          width="226px"
          value={uname}
          onChange={(e) => {
            setUname(e.target.value);
            // handleValidation();
          }}
        />
        <Input
          type="password"
          label="Password"
          placeholder=""
          value={pass}
          required={true}
          width="226px"
          onChange={(e) => {
            setPass(e.target.value);
            // handleValidation();
          }}
        />
      </div>
    </BaseModal>
    </>
  );
};

export default ManualCameraUserLogin;
